/* React */
import React, { useState } from "react";

/* React Redux */
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

/* React Spring */
import { useSpring, animated } from "@react-spring/web";

/* Ionic */
import { IonBackdrop } from "@ionic/react";
import { close } from "ionicons/icons";

/* Components */
import Avatar from "src/components/menus/user-menu/avatar/Avatar";
import NavItem from "src/components/shared/nav-item/NavItem";
import Logout from "src/components/menus/user-menu/logout/Logout";
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./UserMenu.module.scss";

/* Interfaces */
import { NavItemProps } from "src/shared/interfaces/common/NavItem";
import { getUserMenuNavItems } from "src/shared/constants/menu/getUserMenuNavItems";

const UserMenu: React.FC = () => {
  const authState = useSelector(
    (state: RootState) => state.auth
  );
  const { data, roles } = authState;
  const isAuthenticated = data?.isAuthenticated ?? false;
  const navItems = getUserMenuNavItems(roles);

  const [showMenu, setShowMenu] = useState<boolean>(false);

  const handleShowMenu = (value: boolean) => {
    setShowMenu(value);
  };

  const menuAnimation = useSpring({
    transform: showMenu
      ? "translateX(0%)"
      : "translateX(100%)",
    opacity: showMenu ? 1 : 0,
    config: { tension: 375, friction: 40 },
    onRest: () => {
      if (!showMenu) setShowMenu(false);
    },
  });

  return isAuthenticated ? (
    <div className={styles.user_menu}>
      {showMenu && (
        <IonBackdrop
          className={styles.backdrop}
          tappable
          onIonBackdropTap={() => setShowMenu(false)}
        />
      )}
      <Avatar
        onClick={() => {
          setShowMenu(true);
        }}
      />
      {showMenu && (
        <animated.div
          data-testid="user-menu"
          className={styles.menu_container}
          style={menuAnimation}
        >
          <PrimaryFabButton
            scssProps={{
              position: "absolute",
              top: 10,
              right: 10,
              background: "transparent",
            }}
            className={"small"}
            icon={close}
            ariaLabel={"Close"}
            onClick={() => setShowMenu(false)}
          />
          <div className={styles.wrapper_container}>
            {navItems.map(
              (item: NavItemProps, index: number) => (
                <NavItem
                  key={index}
                  scssProps={{ borderRadius: "4px" }}
                  item={item}
                  showLines={true}
                  showName={true}
                  disabled={item.disabled}
                  onClick={handleShowMenu}
                />
              )
            )}
            <Logout />
          </div>
        </animated.div>
      )}
    </div>
  ) : undefined;
};

export default UserMenu;
